export const ADD_CITY = 'ADD_CITY'
export const GET_CITY = 'GET_CITY'